"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import { motion } from "framer-motion";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
export default function AboutSolution() {
  const $ = _c(32);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 50
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t5 = <motion.h2 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="font-poppins mb-6 max-w-[650px] text-[30px] font-bold leading-[1.35] text-[#141047] sm:text-[36px] lg:text-[44px] dark:text-white">Empowering Healthcare with a Smart OPD Management CRM</motion.h2>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="mb-8 max-w-[650px] text-[16px] leading-[31px] text-[#6b7280] lg:text-[17px] dark:text-gray-400">Our OPD Management CRM streamlines doctor appointments, enhances patient engagement, and optimizes clinic operations. With automated scheduling, secure patient records, and real-time insights, it simplifies healthcare management, ensuring efficiency, improved communication, and a seamless experience for doctors and patients alike.</p>;
    t7 = <h2 className="font-poppins mb-7 text-[20px] font-bold text-[#141047] md:text-[22px] dark:text-white">Looking for a Custom OPD Management CRM?</h2>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div><GradientButton href="/contact" variant="peach-pink">Contact Us! <FaChevronRight className="ml-1 text-[12px]" /></GradientButton></div>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5) {
    t9 = <div className="order-2 flex flex-col justify-center">{t5}{t6}{t7}{t8}</div>;
    $[15] = t5;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      opacity: 0
    } : false;
    $[17] = desktopAnimations;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== desktopAnimations) {
    t11 = desktopAnimations ? {
      opacity: 1
    } : undefined;
    $[19] = desktopAnimations;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== desktopAnimations) {
    t12 = desktopAnimations ? undefined : {
      opacity: 1
    };
    $[21] = desktopAnimations;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      duration: 0.6
    };
    t14 = {
      once: true
    };
    $[23] = t13;
    $[24] = t14;
  } else {
    t13 = $[23];
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12) {
    t15 = <div className="order-1 flex justify-center lg:justify-start"><motion.img initial={t10} whileInView={t11} animate={t12} transition={t13} viewport={t14} src="/images/dr-crm/about-healthcare.png" alt="Smart OPD Management CRM" className="w-full max-w-[660px] animate-[float_4s_ease-in-out_infinite] object-contain" /></div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t9) {
    t16 = <section className="bg-white py-16 md:py-24 px-6 font-sans overflow-hidden dark:bg-gray-900"><div className="mx-auto w-full max-w-[1290px]"><div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-12">{t9}{t15}</div></div></section>;
    $[29] = t15;
    $[30] = t9;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
}